import axiosInstance from './axiosInstance';

export async function getBetaAccess(): Promise<boolean> {
  const res = await axiosInstance.get<{ isBeta: boolean }>('/beta/access');
  return res.data.isBeta;
}
